export default __webpack_public_path__ + "712d64da16c45a63999845efea249b11.png";